import React, {Component} from 'react';
import ReactMarkdown from 'react-markdown';
import readme from './README.md';

import components from '../../styles/_vars.scss';

// todo: should get this information out of a README.md
export default class Modifiers extends Component {
  render() {
    return (
      <div className={[components.page]}>
        <ReactMarkdown source={readme}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Modifiers/index.js